export { default } from "./ProductItemReportContent";
